import { Box, TablePagination } from "@mui/material"
import React, { useCallback } from "react";

const Pagination = ({items, children, type='Résultats', className}) => {

    // PAGINATIONN
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginate = useCallback((results) => {

        let startIndex = rowsPerPage * page
        let endIndex = startIndex + rowsPerPage
        return results.slice(startIndex, endIndex)

    }, [page, rowsPerPage])

    const displayedLabelRows = () => {
        return type + ' par page';
    };

    //classtest '& MuiToolbar-root MuiToolbar-regular MuiTablePagination-toolbar --> display block
    //classtest '& MuiTablePagination-selectLabel -->     float: left; padding: 4px;
    //classtest '& div MuiInputBase-root MuiInputBase-colorPrimary --> float: left; margin: 0;
    //classtest & p MuiTablePagination-displayedRows --> float right
    //classtest & div MuiTablePagination-actions --> float right

    return (
        <Box>
        <TablePagination
            className={className}
            component="div"
            labelRowsPerPage={displayedLabelRows()}
            count={items.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            // gap: 1, // Espace entre les cartes
            maxHeight: '540px', // hauteur limite
            overflowY: 'auto', // Active le scroll vertical si nécessaire
          }}
        >

            {paginate(children).map((child, idx) => (
                <React.Fragment key={idx}>{child}</React.Fragment>
            ))}
        </Box>
        </Box>

    )
}

export default Pagination